// extracted by mini-css-extract-plugin
export var hidden = "_sr-0";